/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateRunbookRunRequestRunbookRun } from '../models';
// @ts-ignore
import type { ListRunbookRunsResponse } from '../models';
// @ts-ignore
import type { RunbookRun } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateRunbookRunRequest } from '../models';
/**
 * RunbookRunsAPIApi - axios parameter creator
 * @export
 */
export const RunbookRunsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a runbook run.
         * @summary Create runbook run.
         * @param {string} runbookRunOrganizationId 
         * @param {CreateRunbookRunRequestRunbookRun} createRunbookRunRequestRunbookRun 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookRunsAPICreateRunbookRun: async (runbookRunOrganizationId: string, createRunbookRunRequestRunbookRun: CreateRunbookRunRequestRunbookRun, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runbookRunOrganizationId' is not null or undefined
            assertParamExists('runbookRunsAPICreateRunbookRun', 'runbookRunOrganizationId', runbookRunOrganizationId)
            // verify required parameter 'createRunbookRunRequestRunbookRun' is not null or undefined
            assertParamExists('runbookRunsAPICreateRunbookRun', 'createRunbookRunRequestRunbookRun', createRunbookRunRequestRunbookRun)
            const localVarPath = `/application-automation/v1alpha/organizations/{runbook_run.organization_id}/runbook-runs`
                .replace(`{${"runbook_run.organization_id"}}`, encodeURIComponent(String(runbookRunOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRunbookRunRequestRunbookRun, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists runbook runs.
         * @summary List runbook runs.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [clusterId] The ID of the cluster.
         * @param {string} [runbookId] The ID of the runbook.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {RunbookRunsAPIListRunbookRunsStatusEnum} [status] Status of runbook runs to filter by.
         * @param {RunbookRunsAPIListRunbookRunsPrStatusEnum} [prStatus] PR status to filter by.
         * @param {string} [searchTerm] Search is a plain-text search over runbook run details.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {RunbookRunsAPIListRunbookRunsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {RunbookRunsAPIListRunbookRunsVulnerabilityFixPhaseEnum} [vulnerabilityFixPhase] Phase for a run of type IMAGE_VULNERABILITY_REMEDIATION.
         * @param {string} [complianceFixDetailsRuleId] The ID of the compliance rule to fix.
         * @param {string} [complianceFixDetailsResourceId] The ID of the resource for which to fix the compliance violation.
         * @param {string} [complianceFixDetailsSeverity] The severity of the compliance violation.
         * @param {string} [complianceFixDetailsRuleName] The name of the compliance rule to fix.
         * @param {string} [complianceFixDetailsResourceName] The name of the resource for which to fix the compliance violation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookRunsAPIListRunbookRuns: async (organizationId: string, clusterId?: string, runbookId?: string, pageLimit?: string, pageCursor?: string, status?: RunbookRunsAPIListRunbookRunsStatusEnum, prStatus?: RunbookRunsAPIListRunbookRunsPrStatusEnum, searchTerm?: string, sortField?: string, sortOrder?: RunbookRunsAPIListRunbookRunsSortOrderEnum, vulnerabilityFixPhase?: RunbookRunsAPIListRunbookRunsVulnerabilityFixPhaseEnum, complianceFixDetailsRuleId?: string, complianceFixDetailsResourceId?: string, complianceFixDetailsSeverity?: string, complianceFixDetailsRuleName?: string, complianceFixDetailsResourceName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbookRunsAPIListRunbookRuns', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-runs`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (runbookId !== undefined) {
                localVarQueryParameter['runbookId'] = runbookId;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (prStatus !== undefined) {
                localVarQueryParameter['prStatus'] = prStatus;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (vulnerabilityFixPhase !== undefined) {
                localVarQueryParameter['vulnerabilityFixPhase'] = vulnerabilityFixPhase;
            }

            if (complianceFixDetailsRuleId !== undefined) {
                localVarQueryParameter['complianceFixDetails.ruleId'] = complianceFixDetailsRuleId;
            }

            if (complianceFixDetailsResourceId !== undefined) {
                localVarQueryParameter['complianceFixDetails.resourceId'] = complianceFixDetailsResourceId;
            }

            if (complianceFixDetailsSeverity !== undefined) {
                localVarQueryParameter['complianceFixDetails.severity'] = complianceFixDetailsSeverity;
            }

            if (complianceFixDetailsRuleName !== undefined) {
                localVarQueryParameter['complianceFixDetails.ruleName'] = complianceFixDetailsRuleName;
            }

            if (complianceFixDetailsResourceName !== undefined) {
                localVarQueryParameter['complianceFixDetails.resourceName'] = complianceFixDetailsResourceName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates runbook run for a runbook.
         * @summary Updates runbook run for a runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the run to be updated.
         * @param {UpdateRunbookRunRequest} updateRunbookRunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookRunsAPIUpdateRunbookRun: async (organizationId: string, clusterId: string, id: string, updateRunbookRunRequest: UpdateRunbookRunRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbookRunsAPIUpdateRunbookRun', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('runbookRunsAPIUpdateRunbookRun', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('runbookRunsAPIUpdateRunbookRun', 'id', id)
            // verify required parameter 'updateRunbookRunRequest' is not null or undefined
            assertParamExists('runbookRunsAPIUpdateRunbookRun', 'updateRunbookRunRequest', updateRunbookRunRequest)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/runbook-runs/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRunbookRunRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RunbookRunsAPIApi - functional programming interface
 * @export
 */
export const RunbookRunsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RunbookRunsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a runbook run.
         * @summary Create runbook run.
         * @param {string} runbookRunOrganizationId 
         * @param {CreateRunbookRunRequestRunbookRun} createRunbookRunRequestRunbookRun 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbookRunsAPICreateRunbookRun(runbookRunOrganizationId: string, createRunbookRunRequestRunbookRun: CreateRunbookRunRequestRunbookRun, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunbookRun>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbookRunsAPICreateRunbookRun(runbookRunOrganizationId, createRunbookRunRequestRunbookRun, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbookRunsAPIApi.runbookRunsAPICreateRunbookRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists runbook runs.
         * @summary List runbook runs.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [clusterId] The ID of the cluster.
         * @param {string} [runbookId] The ID of the runbook.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {RunbookRunsAPIListRunbookRunsStatusEnum} [status] Status of runbook runs to filter by.
         * @param {RunbookRunsAPIListRunbookRunsPrStatusEnum} [prStatus] PR status to filter by.
         * @param {string} [searchTerm] Search is a plain-text search over runbook run details.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {RunbookRunsAPIListRunbookRunsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {RunbookRunsAPIListRunbookRunsVulnerabilityFixPhaseEnum} [vulnerabilityFixPhase] Phase for a run of type IMAGE_VULNERABILITY_REMEDIATION.
         * @param {string} [complianceFixDetailsRuleId] The ID of the compliance rule to fix.
         * @param {string} [complianceFixDetailsResourceId] The ID of the resource for which to fix the compliance violation.
         * @param {string} [complianceFixDetailsSeverity] The severity of the compliance violation.
         * @param {string} [complianceFixDetailsRuleName] The name of the compliance rule to fix.
         * @param {string} [complianceFixDetailsResourceName] The name of the resource for which to fix the compliance violation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbookRunsAPIListRunbookRuns(organizationId: string, clusterId?: string, runbookId?: string, pageLimit?: string, pageCursor?: string, status?: RunbookRunsAPIListRunbookRunsStatusEnum, prStatus?: RunbookRunsAPIListRunbookRunsPrStatusEnum, searchTerm?: string, sortField?: string, sortOrder?: RunbookRunsAPIListRunbookRunsSortOrderEnum, vulnerabilityFixPhase?: RunbookRunsAPIListRunbookRunsVulnerabilityFixPhaseEnum, complianceFixDetailsRuleId?: string, complianceFixDetailsResourceId?: string, complianceFixDetailsSeverity?: string, complianceFixDetailsRuleName?: string, complianceFixDetailsResourceName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRunbookRunsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbookRunsAPIListRunbookRuns(organizationId, clusterId, runbookId, pageLimit, pageCursor, status, prStatus, searchTerm, sortField, sortOrder, vulnerabilityFixPhase, complianceFixDetailsRuleId, complianceFixDetailsResourceId, complianceFixDetailsSeverity, complianceFixDetailsRuleName, complianceFixDetailsResourceName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbookRunsAPIApi.runbookRunsAPIListRunbookRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates runbook run for a runbook.
         * @summary Updates runbook run for a runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the run to be updated.
         * @param {UpdateRunbookRunRequest} updateRunbookRunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbookRunsAPIUpdateRunbookRun(organizationId: string, clusterId: string, id: string, updateRunbookRunRequest: UpdateRunbookRunRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbookRunsAPIUpdateRunbookRun(organizationId, clusterId, id, updateRunbookRunRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbookRunsAPIApi.runbookRunsAPIUpdateRunbookRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RunbookRunsAPIApi - factory interface
 * @export
 */
export const RunbookRunsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RunbookRunsAPIApiFp(configuration)
    return {
        /**
         * Creates a runbook run.
         * @summary Create runbook run.
         * @param {RunbookRunsAPIApiRunbookRunsAPICreateRunbookRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookRunsAPICreateRunbookRun(requestParameters: RunbookRunsAPIApiRunbookRunsAPICreateRunbookRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunbookRun> {
            return localVarFp.runbookRunsAPICreateRunbookRun(requestParameters.runbookRunOrganizationId, requestParameters.createRunbookRunRequestRunbookRun, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists runbook runs.
         * @summary List runbook runs.
         * @param {RunbookRunsAPIApiRunbookRunsAPIListRunbookRunsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookRunsAPIListRunbookRuns(requestParameters: RunbookRunsAPIApiRunbookRunsAPIListRunbookRunsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListRunbookRunsResponse> {
            return localVarFp.runbookRunsAPIListRunbookRuns(requestParameters.organizationId, requestParameters.clusterId, requestParameters.runbookId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.status, requestParameters.prStatus, requestParameters.searchTerm, requestParameters.sortField, requestParameters.sortOrder, requestParameters.vulnerabilityFixPhase, requestParameters.complianceFixDetailsRuleId, requestParameters.complianceFixDetailsResourceId, requestParameters.complianceFixDetailsSeverity, requestParameters.complianceFixDetailsRuleName, requestParameters.complianceFixDetailsResourceName, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates runbook run for a runbook.
         * @summary Updates runbook run for a runbook.
         * @param {RunbookRunsAPIApiRunbookRunsAPIUpdateRunbookRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookRunsAPIUpdateRunbookRun(requestParameters: RunbookRunsAPIApiRunbookRunsAPIUpdateRunbookRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.runbookRunsAPIUpdateRunbookRun(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.updateRunbookRunRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for runbookRunsAPICreateRunbookRun operation in RunbookRunsAPIApi.
 * @export
 * @interface RunbookRunsAPIApiRunbookRunsAPICreateRunbookRunRequest
 */
export interface RunbookRunsAPIApiRunbookRunsAPICreateRunbookRunRequest {
    /**
     * 
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPICreateRunbookRun
     */
    readonly runbookRunOrganizationId: string

    /**
     * 
     * @type {CreateRunbookRunRequestRunbookRun}
     * @memberof RunbookRunsAPIApiRunbookRunsAPICreateRunbookRun
     */
    readonly createRunbookRunRequestRunbookRun: CreateRunbookRunRequestRunbookRun
}

/**
 * Request parameters for runbookRunsAPIListRunbookRuns operation in RunbookRunsAPIApi.
 * @export
 * @interface RunbookRunsAPIApiRunbookRunsAPIListRunbookRunsRequest
 */
export interface RunbookRunsAPIApiRunbookRunsAPIListRunbookRunsRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly clusterId?: string

    /**
     * The ID of the runbook.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly runbookId?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly pageCursor?: string

    /**
     * Status of runbook runs to filter by.
     * @type {'STATUS_UNSPECIFIED' | 'QUEUED' | 'RUNNING' | 'WAITING' | 'COMPLETED' | 'FAILED' | 'ACTION_REQUIRED' | 'CANCELED' | 'SKIPPED'}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly status?: RunbookRunsAPIListRunbookRunsStatusEnum

    /**
     * PR status to filter by.
     * @type {'PULL_REQUEST_STATUS_UNSPECIFIED' | 'OPENED' | 'MERGED' | 'CLOSED'}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly prStatus?: RunbookRunsAPIListRunbookRunsPrStatusEnum

    /**
     * Search is a plain-text search over runbook run details.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly searchTerm?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly sortOrder?: RunbookRunsAPIListRunbookRunsSortOrderEnum

    /**
     * Phase for a run of type IMAGE_VULNERABILITY_REMEDIATION.
     * @type {'VULNERABILITY_FIX_PHASE_UNSPECIFIED' | 'FIXING_VULNERABILITY' | 'UPDATING_MANIFEST'}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly vulnerabilityFixPhase?: RunbookRunsAPIListRunbookRunsVulnerabilityFixPhaseEnum

    /**
     * The ID of the compliance rule to fix.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly complianceFixDetailsRuleId?: string

    /**
     * The ID of the resource for which to fix the compliance violation.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly complianceFixDetailsResourceId?: string

    /**
     * The severity of the compliance violation.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly complianceFixDetailsSeverity?: string

    /**
     * The name of the compliance rule to fix.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly complianceFixDetailsRuleName?: string

    /**
     * The name of the resource for which to fix the compliance violation.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIListRunbookRuns
     */
    readonly complianceFixDetailsResourceName?: string
}

/**
 * Request parameters for runbookRunsAPIUpdateRunbookRun operation in RunbookRunsAPIApi.
 * @export
 * @interface RunbookRunsAPIApiRunbookRunsAPIUpdateRunbookRunRequest
 */
export interface RunbookRunsAPIApiRunbookRunsAPIUpdateRunbookRunRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIUpdateRunbookRun
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIUpdateRunbookRun
     */
    readonly clusterId: string

    /**
     * The ID of the run to be updated.
     * @type {string}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIUpdateRunbookRun
     */
    readonly id: string

    /**
     * 
     * @type {UpdateRunbookRunRequest}
     * @memberof RunbookRunsAPIApiRunbookRunsAPIUpdateRunbookRun
     */
    readonly updateRunbookRunRequest: UpdateRunbookRunRequest
}

/**
 * RunbookRunsAPIApi - object-oriented interface
 * @export
 * @class RunbookRunsAPIApi
 * @extends {BaseAPI}
 */
export class RunbookRunsAPIApi extends BaseAPI {
    /**
     * Creates a runbook run.
     * @summary Create runbook run.
     * @param {RunbookRunsAPIApiRunbookRunsAPICreateRunbookRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbookRunsAPIApi
     */
    public runbookRunsAPICreateRunbookRun(requestParameters: RunbookRunsAPIApiRunbookRunsAPICreateRunbookRunRequest, options?: RawAxiosRequestConfig) {
        return RunbookRunsAPIApiFp(this.configuration).runbookRunsAPICreateRunbookRun(requestParameters.runbookRunOrganizationId, requestParameters.createRunbookRunRequestRunbookRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists runbook runs.
     * @summary List runbook runs.
     * @param {RunbookRunsAPIApiRunbookRunsAPIListRunbookRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbookRunsAPIApi
     */
    public runbookRunsAPIListRunbookRuns(requestParameters: RunbookRunsAPIApiRunbookRunsAPIListRunbookRunsRequest, options?: RawAxiosRequestConfig) {
        return RunbookRunsAPIApiFp(this.configuration).runbookRunsAPIListRunbookRuns(requestParameters.organizationId, requestParameters.clusterId, requestParameters.runbookId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.status, requestParameters.prStatus, requestParameters.searchTerm, requestParameters.sortField, requestParameters.sortOrder, requestParameters.vulnerabilityFixPhase, requestParameters.complianceFixDetailsRuleId, requestParameters.complianceFixDetailsResourceId, requestParameters.complianceFixDetailsSeverity, requestParameters.complianceFixDetailsRuleName, requestParameters.complianceFixDetailsResourceName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates runbook run for a runbook.
     * @summary Updates runbook run for a runbook.
     * @param {RunbookRunsAPIApiRunbookRunsAPIUpdateRunbookRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbookRunsAPIApi
     */
    public runbookRunsAPIUpdateRunbookRun(requestParameters: RunbookRunsAPIApiRunbookRunsAPIUpdateRunbookRunRequest, options?: RawAxiosRequestConfig) {
        return RunbookRunsAPIApiFp(this.configuration).runbookRunsAPIUpdateRunbookRun(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.updateRunbookRunRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const RunbookRunsAPIListRunbookRunsStatusEnum = {
    STATUS_UNSPECIFIED: 'STATUS_UNSPECIFIED',
    QUEUED: 'QUEUED',
    RUNNING: 'RUNNING',
    WAITING: 'WAITING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    ACTION_REQUIRED: 'ACTION_REQUIRED',
    CANCELED: 'CANCELED',
    SKIPPED: 'SKIPPED'
} as const;
export type RunbookRunsAPIListRunbookRunsStatusEnum = typeof RunbookRunsAPIListRunbookRunsStatusEnum[keyof typeof RunbookRunsAPIListRunbookRunsStatusEnum];
/**
 * @export
 */
export const RunbookRunsAPIListRunbookRunsPrStatusEnum = {
    PULL_REQUEST_STATUS_UNSPECIFIED: 'PULL_REQUEST_STATUS_UNSPECIFIED',
    OPENED: 'OPENED',
    MERGED: 'MERGED',
    CLOSED: 'CLOSED'
} as const;
export type RunbookRunsAPIListRunbookRunsPrStatusEnum = typeof RunbookRunsAPIListRunbookRunsPrStatusEnum[keyof typeof RunbookRunsAPIListRunbookRunsPrStatusEnum];
/**
 * @export
 */
export const RunbookRunsAPIListRunbookRunsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type RunbookRunsAPIListRunbookRunsSortOrderEnum = typeof RunbookRunsAPIListRunbookRunsSortOrderEnum[keyof typeof RunbookRunsAPIListRunbookRunsSortOrderEnum];
/**
 * @export
 */
export const RunbookRunsAPIListRunbookRunsVulnerabilityFixPhaseEnum = {
    VULNERABILITY_FIX_PHASE_UNSPECIFIED: 'VULNERABILITY_FIX_PHASE_UNSPECIFIED',
    FIXING_VULNERABILITY: 'FIXING_VULNERABILITY',
    UPDATING_MANIFEST: 'UPDATING_MANIFEST'
} as const;
export type RunbookRunsAPIListRunbookRunsVulnerabilityFixPhaseEnum = typeof RunbookRunsAPIListRunbookRunsVulnerabilityFixPhaseEnum[keyof typeof RunbookRunsAPIListRunbookRunsVulnerabilityFixPhaseEnum];
